export default "__VITE_ASSET__BBN_H7Ii__"